import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Card, CardText, Divider } from 'react-md';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import ErrorDisplay from '../ErrorDisplay';
import FieldGroup from '../FieldGroup';
import LoaderButton from '../LoaderButton';

import { changePassword } from '../../libs/awsLib';

import './Login.css';

function parseInvalidPasswordException(e) {
  if (e.message.indexOf('Password not long') !== -1) return 'InvalidPasswordExceptionLong';
  if (e.message.indexOf('Password must have upper') !== -1) return 'InvalidPasswordExceptionUpper';
  if (e.message.indexOf('Password must have lower') !== -1) return 'InvalidPasswordExceptionLower';
  if (e.message.indexOf('Password must have numer') !== -1) return 'InvalidPasswordExceptionNumeric';
  if (e.message.indexOf('Password must have symbol') !== -1) return 'InvalidPasswordExceptionSymbol';
  return e.message;
}

function parseInvalidParameterException(e) {
  if (e.message.indexOf('Value at \'previousPassword\' failed') !== -1) return 'ChangePasswordNotAuthorizedException';
  if (e.message.indexOf('Value at \'proposedPassword\' failed') !== -1) return 'InvalidParameterExceptionPassword';
  return e.message;
}

export default injectIntl(class Signup extends Component {
  static propTypes = {
    intl: intlShape.isRequired,
    history: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      email: '',
      password: '',
      confirmPassword: '',
      oldPassword: '',
      error: '',
    };
  }

  validateConfirmationForm() {
    return this.state.oldPassword.length > 0 &&
      this.state.password.length > 0 &&
      this.state.password === this.state.confirmPassword;
  }

  handleChange = (event) => {
    this.setState({
      [event.target.id]: event.target.value.trim(),
      error: undefined,
    });
  };

  handleConfirmationSubmit = async (event) => {
    event.preventDefault();
    this.setState({ isLoading: true });

    try {
      await changePassword(this.state.oldPassword, this.state.password);
      this.props.history.push('/');
    } catch (e) {
      this.setState({ isLoading: false });
      if (e.name === 'LimitExceededException') {
        this.setState({ error: e.name });
      } else if (e.name === 'NotAuthorizedException') {
        this.setState({ error: 'ChangePasswordNotAuthorizedException' });
      } else if (e.name === 'InvalidPasswordException') {
        this.setState({ error: parseInvalidPasswordException(e) });
      } else if (e.name === 'InvalidParameterException') {
        this.setState({ error: parseInvalidParameterException(e) });
      } else {
        console.log(e);
        alert(e.message);
      }
    }
  };

  renderConfirmationForm() {
    const { intl } = this.props;
    const { error } = this.state;
    return (
      <Card>
        <CardText className="welcome">
          <FormattedMessage id="login.definePassword" tagName="h3" />
        </CardText>
        <Divider />
        <CardText>
          <form onSubmit={this.handleConfirmationSubmit}>
            <ErrorDisplay error={error} />
            <FieldGroup
              bsSize="large"
              id="oldPassword"
              autoFocus
              placeholder={intl.formatMessage({ id: 'signup.oldPasswordPlaceholder' })}
              value={this.state.oldPassword}
              onChange={this.handleChange}
              label={intl.formatMessage({ id: 'signup.oldPasswordLabel' })}
              type="password"
            />
            <div className="passwordInstructions">
              <FormattedMessage id="login.instructions.title" />
              <ul>
                <li>8 <FormattedMessage id="login.instructions.characters" /></li>
                <li>1 <FormattedMessage id="login.instructions.uppercase" /></li>
                <li>1 <FormattedMessage id="login.instructions.number" /></li>
                <li>1 <FormattedMessage id="login.instructions.symbol" />{' (# @ & ! ? $ { } / \\  * - … )'}</li>
              </ul>
            </div>

            <FieldGroup
              id="password"
              label={intl.formatMessage({ id: 'signup.passwordLabel' })}
              bsSize="large"
              placeholder={intl.formatMessage({ id: 'signup.passwordPlaceholder' })}
              value={this.state.password}
              onChange={this.handleChange}
              type="password"

            />


            <FieldGroup
              id="confirmPassword"
              label={intl.formatMessage({ id: 'signup.confirmPasswordLabel' })}
              bsSize="large"
              placeholder={intl.formatMessage({ id: 'signup.confirmPasswordPlaceholder' })}
              value={this.state.confirmPassword}
              onChange={this.handleChange}
              type="password"
              validationState={this.state.confirmPassword !== this.state.password ? 'error' : null}
            />

            <LoaderButton
              flat
              swapTheming
              primary
              className="md-full-width big last"
              disabled={!this.validateConfirmationForm()}
              type="submit"
              isLoading={this.state.isLoading}
              text={intl.formatMessage({ id: 'login.definePasswordButton' })}
              loadingText={intl.formatMessage({ id: 'login.definePasswordButtonBussy' })}
            />
          </form>
        </CardText>
      </Card>
    );
  }

  render() {
    return (
      <div className="md-block-centered login">
        <div className="lander">
          <div className="logo md-block-centered" />
          {this.renderConfirmationForm()}
        </div>
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/components/Login/ChangePassword.js